// Do not modify this file, it is generated automatically by the script update-contract-addresses.mjs!

export const addresses = {
	Oil: "0xca80bfcb11937797896f6ea3fcc70a4d1e2528c6",
	Bit: "0x10ef8736545726efdd086dde8311c4dddfbeb9f2",
	Reward: "0x0e48b753369847983cdc455b977d58c3e79b6454",
	BotMetadata: "0x35dc9adef7065768ec273f81ef7613489d8374aa",
	BotRevealer: "0x58fbc9b214eb667777bb4b7c0f30943ee2196ad2",
	BotRent: "0x1e8776decb269d96c01cc333b4c202e06144680e",
	ShipMetadata: "0x761cc3792e90d9d090a0e9478d2e0eb8730422bf",
	ShipRevealer: "0x7778968d3e7f41a807c3a63019e849f2d0987e27",
	ShipTeam: "0xbf4a66234aa507baffabef11fd1855255252e659",
	AllianceStaking: "0x4e33feb4193d0fbacaace0af29264e7f5d62ac87",
	Bot: "0x52fead50bb1e7e4f1144843da7938bf4446291cf",
	Ship: "0xcf5853ce6f6ceee0ff9df478b3e75e1ad654e4cf",
	BotTeam: "0x73cd5c286658bcc56f297f9ee7119e1ea9fbefa6",
	ShipRent: "0xc34b7e7c0667a117513e7ed93f064478f29494f9",
	Marketplace: "0x9e0a9bdf3f84d51b1bfd7c41f450de9fb8abb114",
	BotMinter: "0x1da49aa3ba2eca5a00dc4f1d7d839e397e987d3a",
	BotUpgrader: "0xbcd0f217369b631853fef6895b9ec1613068d255",
	ShipMinter: "0x4e0651d84d010f29efdf5a57c9b475f4e933138e",
	RewardEarlyClaim: "0x5ee89795f1e3cb9ea26478d2179fa863c0955563",
	VotingEscrow: "0xdb4296d2f5a495ed873b6634d01e81ab9e207225",
	DamageFix: "0x75822fc231eefc6ac0fbd54b28e091331798cb04",
	BotShipPool: "0xb96a28ff5a193e840bc6f201aa050a24837afab4",
}
